/*
dropdownSettingRow.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { SyntheticEvent, PropsWithChildren } from 'react'
import { getBrowserType } from '../../../modules/deviceModel'
import { BrowserTypeEnum } from '../../../types/browserTypeEnum'
import { scrollerClickEvent } from '../../../components/scrollWrapper'
// import iScroll, { Options as IScrollOptions } from 'iscroll'
interface DropdownSettingRowProps {
  isOpen: boolean
  setIsOpen:React.Dispatch<React.SetStateAction<boolean>>
}

export default function DropdownSettingRow (props: PropsWithChildren<DropdownSettingRowProps>) {
  const { isOpen, setIsOpen, children } = props;
  const browserType = getBrowserType();
const handleRowClick = (
  e: SyntheticEvent | PointerEvent | MouseEvent | TouchEvent
) => {
  if (browserType == BrowserTypeEnum.ThirdGen) {
    const target = e.target as HTMLElement
    const customEvent: CustomEvent = new CustomEvent(scrollerClickEvent,
      {
          bubbles: true,
        detail: {
          x: 0,
          y: 0
        }
      }
    )
    if ('touches' in e && e.changedTouches.length > 0) {
      customEvent.detail.x =  e.changedTouches[0].clientX
      customEvent.detail.x =  e.changedTouches[0].clientY
      }
      else if ('touches' in e && e.touches.length > 0) {
      customEvent.detail.x =  e.touches[0].clientX
      customEvent.detail.x =  e.touches[0].clientY
    } else if ('pointerId' in e) {
      customEvent.detail.x = (e as PointerEvent).clientX
      customEvent.detail.x = (e as PointerEvent).clientY
    } else if (e['clientX'] !== undefined && e['clientY'] !== undefined) {
      customEvent.detail.x =  e['clientX']
      customEvent.detail.y =  e['clientY']
        }
      target.dispatchEvent(customEvent)
    }
  setIsOpen(!isOpen)
}
  return (
    <>
          <a onClick={handleRowClick} className='dropdown-list-link'>
            {children}
      </a>
    </>
  )
}